// extracted by css-extract-rspack-plugin
export default {"titleWithVacancy":"title-with-vacancy--CU7jAlpfYM8fRVWX","vacancyChip":"vacancy-chip--AYKlPFckhA0xA0VV"};